export const JOB_TYPES = [
  { "value": -1, "label": "Offshore Crew" },
  { "value": -2, "label": "Project Crew" },
  { "value": -3, "label": "Main Fleet Crew" },
  { "value": -4, "label": "Diving Crew" },
  { "value": -5, "label": "Survey Team" },
  { "value": -6, "label": "Rov Team" },
  { "value": -7, "label": "Riding Squad" },
  { "value": -8, "label": "Marine Specialist" }
]
